module.exports = __webpack_public_path__ + "static/media/login-bg.35ac64e9.png";